import { render } from "./MessageReport.vue?vue&type=template&id=7da45509&scoped=true&ts=true"
import script from "./MessageReport.vue?vue&type=script&lang=ts"
export * from "./MessageReport.vue?vue&type=script&lang=ts"

import "./MessageReport.vue?vue&type=style&index=0&id=7da45509&lang=scss&scoped=true"

import exportComponent from "/var/www/widget.surveybot.me/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7da45509"]])

export default __exports__